export default __webpack_public_path__ + "static/N0129-54af11e2c7e6748497dd086845006fcf.png";